import { useContext } from 'react';
import { SelectedTimestampContext } from './selectedTimestampTypes';

export const useSelectedTimestamp = () => {
  const context = useContext(SelectedTimestampContext);
  if (!context) {
    throw new Error('useSelectedTimestamp must be used within SelectedTimestampProvider');
  }
  return context;
};

